import { z } from 'zod/v4';

/**
 * An order number. A number is accepted and read as its string — the old
 * frontend sends `0` for a row with no sales-order number, which the legacy
 * route's validator coerced to `"0"`.
 */
const OrderNumberSchema = z
  .union([z.string().min(1), z.number().transform(String)])
  .pipe(z.string());

export const CheckAttachmentTemplatesBodySchema = z
  .array(
    z.object({
      purchaseOrderNumber: OrderNumberSchema,
      salesOrderNumber: OrderNumberSchema,
      /** The caller's row index, echoed back on a mismatch. */
      index: z.number().optional(),
    }),
  )
  .min(1);

export type CheckAttachmentTemplatesBody = z.infer<
  typeof CheckAttachmentTemplatesBodySchema
>;

/** A pair whose two orders both exist but use different attachment templates. */
export const AttachmentTemplateMismatchSchema = z.object({
  purchaseOrderNumber: z.string(),
  purchaseOrderAttachmentTemplateId: z.string().nullable(),
  salesOrderNumber: z.string(),
  salesOrderAttachmentTemplateId: z.string().nullable(),
  index: z.number().nullable(),
});

export type AttachmentTemplateMismatch = z.infer<
  typeof AttachmentTemplateMismatchSchema
>;

export const AttachmentTemplateMismatchListSchema = z.array(
  AttachmentTemplateMismatchSchema,
);

/** Wire shape: the standard `reply.apiSuccess` envelope around the mismatches. */
export const CheckAttachmentTemplatesResponseSchema = z.object({
  metadata: z.object({ success: z.literal(true) }),
  data: AttachmentTemplateMismatchListSchema,
});

export type CheckAttachmentTemplatesResponse = z.infer<
  typeof CheckAttachmentTemplatesResponseSchema
>;
